<template>
    <div class="addTicket">
        <!-- 添加券号信息 -->
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-col :span="22">
                                <el-select v-model="value9" filterable placeholder="试一试搜索:销售地点" clearable  @change="handleChange2" :loading="loading" size = "large">
                                    <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="免费招待" prop="complimentary" >
                            <el-col :span="22">
                                <el-input v-model="ruleForm.complimentary" placeholder="请输入地点名称" :disabled="true"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item
                            label="券号"
                            prop="voucherCode"
                        >
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength="8"></el-input>
                            </el-col>
                            <el-col :span="1" :offset="1"> - </el-col>
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value2" :maxlength="8"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        var validatorQty = (rule,value,callback) => {
            let value1 = Number.isInteger(value.value1) ;
            let value2 = Number.isInteger(value.value2) ;
            if(value.value1 == ''){
                callback(new Error("第一个券号不能为空！"));
            }else{
                if(value.value1 != '' && value.value2 == ''){
                    let val = this.trim(value.value1);
                     console.log(value.value1.length)
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false){
                        callback(new Error("请填写大于0的数字"));
                        console.log('请填写大于0的数字')
                    }else if(/[+]/g.test(value.value1)){
                        //console.log('包含加号')
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }
                    else{
                        callback();
                    }
                }else if(value.value2 != '' && value.value1 != ''){
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value2) == false || (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false){
                        callback(new Error("请填写大于0的数字"));
                    }else if(value.value2 - value.value1 < 0){
                        callback(new Error("第二位数要大于第一位数"));
                    }else if(value.value2 < 0 || value.value1 < 0){
                        callback(new Error("必须填写大于0的数字"));
                    }else if(/[+]/g.test(value.value2) || /[+]/g.test(value.value1)){
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value2.length != 8 || value.value1.length != 8){
                        callback(new Error("请输入8位数的券号!"));
                    }else{
                        callback();
                    }
                }
            }
        }
        return {
            ruleForm:{
                //description:'',
                //quantity:'333',
                voucherCode:{
                    value1:"",
                    value2:""
                },
                locationCode:'',
                complimentary:''
            },
            rules:{
                voucherCode:[
                     {  validator : validatorQty,trigger:'blur',type:'number'},
                     { required: true, message: '请填写券号', trigger:'blur'}
                ],
                // complimentary:[
                //     { required: true, message: '请先选择类型编号'}
                // ],
                // typeCode:[
                //     { required: true, message: '请选择类型编号', trigger:'blur'}
                // ],
                // description: [
                //     { required: true, message: '请填写类型名称', trigger: 'blur' },
                //     // { min: 2, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                // ],
                locationCode: [
                    { required: true, message: '请填写地点名称', trigger: 'blur' },
                    // { min: 2, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                ],
                quantity:[
                    { required : true},
                    // { min: 1, max: 5, message: '长度在 1 到 5 个数字', trigger: 'blur' }
                ],
            },
            value9:'',
            options2:[
                {
                    value : '', 
                    label : ''
                }
            ],
            selectData:''
        }
    },
    created (){
       
    },
    mounted(){
        let { description,typeCode } = this.$route.query ;
        this.ruleForm.description = description;
        this.ruleForm.typeCode = typeCode ;
        this.loadingArea();
    },
    methods:{
        //保存券号信息
        submitForm(formName) {   
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let userId = sessionStorage.getItem("userId") ;
                    let { typeCode , voucherCode, complimentary ,locationCode} = this.ruleForm ;
                    if(complimentary == '是'){
                        complimentary = 'Y'
                    }else if(complimentary == '否'){
                        complimentary = 'N'
                    } 
                    let params = {
                        act : 'dsCoupons',
                        shop : locationCode ,
                        from : voucherCode.value1,
                        to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                        complimentary : complimentary,
                        userId
                    }
                    this.$confirm(`是否分配券号 ${params.from} - ${params.to} `,'提示',{
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center :true

                    }).then( () =>{
                        let loading = this.loadingCommon();
                        this.delType(params).then( (res) =>{
                            if(res.data.status == true && res.data.data.qty !== '0'){
                                loading.close();
                                this.$confirm(`已分配成功 ${res.data.data.qty}`, '提示', {
                                        confirmButtonText: '确定',
                                        showCancelButton : false ,
                                        type: 'success'
                                    }).then(() => {
                                        //this.reload(); //刷新当前页面
                                        this.promptMsg('分配成功','success')
                                        this.value9 = '' ;
                                        this.ruleForm.locationCode = '';
                                        this.ruleForm.complimentary = '';
                                        this.ruleForm.voucherCode.value1 = '';
                                        this.ruleForm.voucherCode.value2 = '';
                                    }).catch(() => {
                                        this.promptMsg('已取消','info');         
                                    });
                            }else if(res.data.status == true && res.data.data.qty == '0'){
                                loading.close();
                                this.$confirm('已分配成功 0', '提示', {
                                        confirmButtonText: '确定',
                                        showCancelButton : false ,
                                        type: 'success'
                                    }).then(() => {
                                        // this.$router.push({ path:'/ticket/distributionList' }) ;
                                        this.alert('请查看券号是否输入正确或券号已经分配 !','warning')
                                    }).catch(() => {
                                        this.promptMsg('已取消','info');;          
                                    });
                            }
                            else{
                                loading.close();
                                if(res.data.msg){
                                    this.alert('分配失败', 'warning')
                                }else{
                                    this.alert('分配失败', 'warning')
                                }
                            }
                        })
                    }).catch((error) => {
                        this.promptMsg('已取消','info');
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },

        /**
         * 修改票券信息
         */
        modifyTicket(){
            let that = this;
            let tickedList = JSON.parse(sessionStorage.getItem('tickedList'));
            let index = that.$route.query.index;
        },
        /**
         * 搜索加载地区选项
        */
        loadingArea(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findLocations',
                userId
            }
            this.findType(params).then( (res) => {
                if(res.data.status == true){
                    let result = res.data.list;
                    this.sortChinese(result,"description");
                    this.selectData = result;
                    let location = result.map( (elem, index, arr) => {
                        return { value : elem.locationCode ,label:elem.description }
                    })
                    this.options2 = location;
                }
            })
        },
        /**
         * 销售地点change
         */
        handleChange2(value){
            this.ruleForm.locationCode = value;
            let selectData = this.selectData ;
            selectData.forEach((elem,index,array) =>{
                if(elem.locationCode == value){
                    this.ruleForm.complimentary = elem.complimentary;
                    if(this.ruleForm.complimentary == 'Y'){
                         this.ruleForm.complimentary = '是'
                    }else{
                        this.ruleForm.complimentary = '否'
                    }
                }
            }); 
        }
    }

}
</script>
